import { MDBAutocomplete, MDBCheckbox } from 'mdb-react-ui-kit';
import React, { forwardRef, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { validatePhoneNumber } from '../phonenumbers/AddRemoveNumbers';

const EditExterNum = forwardRef((props, ref) => {
  const { t, i18n } = useTranslation();
  const [callerchecked, setCallerChecked] = useState(true);
  const [selectedValue, setselectedValue] = useState("");
  const [callerIdList, setcallerIdList] = useState([]);
  const [displayCallerIds, setdisplayCallerIds] = useState([]);
  const [externalId, setexternalId] = useState(0);
  const { register, setValue, formState: { isDirty, errors, dirtyFields }, setError, handleSubmit, reset, getValues, watch } = useForm({
    defaultValues: {
      name: "",
      uniqueid: "",
      cid_pass: "",
      cid_pass_flag: true,
    }
  });

  useEffect(() => {
    if (props?.externalInfo && Object.entries(props.externalInfo).length > 0) {
      setselectedValue(props?.externalInfo?.cid_pass ?? "");
      setexternalId(props?.externalInfo?.ph_id ?? 0);
      reset({
        name: props?.externalInfo?.title ?? "",
        uniqueid: props?.externalInfo?.phnumber ?? "",
        cid_pass: props?.externalInfo?.cid_pass ?? "",
        cid_pass_flag: props?.externalInfo?.cid_pass_flag ?? true,
      })
    }
    if (props.callerids && props.callerids.length > 0) {
      setcallerIdList(props.callerids);
      setdisplayCallerIds(props.callerids);
    }

  }, [props.externalInfo, props.callerids])

  const onsubmit = async (data) => {
    //alert(JSON.stringify(data));
    props.setExternError([]);
    const modifiedData = {};
    if (isDirty) {

      for (const field of Object.keys(dirtyFields)) {
        if (dirtyFields[field] && data.hasOwnProperty(field)) {
          modifiedData[field] = data[field];
        }
      }
      if (modifiedData) {
        modifiedData.val = externalId ? parseInt(externalId) : 0;
      }

      props.setExDetails(modifiedData);
      props.setExEdited(true);
    }
  }

  useEffect(() => {
    //alert(JSON.stringify(externError));
    if (props.externError && props.externError.length > 0) {

      props.externError.forEach((err) => {
        let fieldName = "";
        if (err.param_name.toString().includes('.')) {
          const splitArr = err.param_name.toString().split('.');
          fieldName = splitArr[splitArr.length - 1];

        } else {
          fieldName = err.param_name.toString();

        }
        setError(fieldName, {
          type: "server",
          message: err.message,
        });
      });
    }

  }, [props.externError]);

  function handleChange(e, result) {
    e.preventDefault();
    console.log("value :::::::::::::: " + JSON.stringify(result));
    setValue("cid_pass", result.phnum, { shouldDirty: true });
  }

  const onCustomSearch = (value) => {
    const lowercasedValue = value.toLowerCase();
    if (lowercasedValue.trim() !== "") {
      const filteredData = callerIdList.filter((item) => item.addl_info.toLowerCase().includes(lowercasedValue));
      setdisplayCallerIds(filteredData);
    } else {
      setdisplayCallerIds([]);
    }
  };

  return (
    <>
      <div className="pb-3">
        <div>
          <div className="tel-numbers fw-bold">{t("name")}</div>
        </div>
        <div className="w-100">
          <div className="w-100">
            <input
              type="text" maxLength={30}
              {...register("name", { required: "Name should not be empty" })}
              className="selectname w-100"
            />
            {errors.name && (
              <p className="text-danger">{errors.name.message}</p>
            )}
          </div>
        </div>

        <div className="mt-2">
          <div className="tel-numbers fw-bold">{t("Number")}</div>
        </div>
        <div className="w-100">
          <div className="w-100">
            <input
              type="text"
              onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) {
                  event.preventDefault();
                }
              }}
              {...register("uniqueid", {
                // setValueAs: (value) => Number(value),
                required: "number should not be empty",
                validate: validatePhoneNumber,
              })}
              className="selectname w-100"
            />
            {errors.uniqueid && (
              <p className="text-danger">{errors.uniqueid.message}</p>
            )}
          </div>
        </div>

        {props.calleridFlag && (
          <>
            <div className='mt-2 d-flex align-itemd-center justify-content-between w-100'>
              <div className="tel-numbers fw-bold">{t("CallerIDpasstrough")}</div>
              <MDBCheckbox name='checkNoLabel' id='checkboxNoLabel' checked={getValues("cid_pass_flag")} onChange={(e) => {
                setCallerChecked((obj) => !obj);
                setValue("cid_pass_flag", e.target.checked, { shouldDirty: true });
              }} aria-label='...' />
            </div>
            <div className="phoneselect mt-2">
              <select
                className="form-control form-select selectname"
                name="Default"
                disabled={watch("cid_pass_flag")}
                {...register("cid_pass")}
              >
                <option value="">Choose Caller ID...</option>
                {props.callerids && props.callerids.length > 0 && (props.callerids.map((item) => (
                  <option value={item.phnum}>{item.addl_info}</option>
                )))}

              </select>
              {/* <MDBAutocomplete
                disabled={watch("cid_pass_flag")}
                data={displayCallerIds}
                value={selectedValue}
                displayValue={(row) => row.addl_info}
                placeholder={"Search Caller ID..."}
                onChange={(value) => setselectedValue(value)}
                onSearch={onCustomSearch}
                itemContent={(result) => (
                  <div onClick={(e) => handleChange(e, result)}>{`${result.addl_info}`}</div>
                )}
              /> */}
              {errors.cid_pass && (
                <p className="text-danger">{errors.cid_pass.message}</p>
              )}
            </div>
          </>
        )}

      </div>
      <div style={{ display: "none" }}>
        <button ref={ref} onClick={handleSubmit(onsubmit)}>
          {t("add")}</button>
      </div>

    </>
  )
});
export default EditExterNum;
